import { Device } from '@hc-frontend/core-types';
import { z } from 'zod';

const APPLICANT_GENDER = {
  male: 1,
  female: 2,
} as const;

const BaseFeaturedAdsListPayloadDto = z.object({
  hc_maxregs: z.number(),
  hc_state: z.string(),
  hc_zip: z.string(),
  hc_qle: z.number(),
  hc_household_income: z.number(),
  hc_household_size: z.number(),
  hc_children_amount: z.number(),
  hc_beneficiary_type: z.literal('member'),
  hc_subsidy_eligibility: z.boolean(),
  hc_session: z.string(),
  uid: z.string(),
  PlansSearchSessionId: z.string(),
  utm_source: z.string(),
  mapped_source: z.string(),
  src: z.string(),
  subid: z.string(),
  bt_sid: z.string(),
  goal_url: z.literal(''),
  hc_plan_search_id: z.literal(''),
  irpid: z.string(),
  hc_applicant_dob: z.string().optional(),
  hc_applicant_gender: z.nativeEnum(APPLICANT_GENDER).optional(),
  hc_smoker_applicant: z.enum(['Y', 'N']).optional(),
  branded_campaigns: z.string().optional(),
});

const HealthFeaturedAdsListPayloadDto = z
  .object({
    product: z.literal('HEALTH'),
    hc_product_type: z.literal(1),
    device: Device,
  })
  .merge(BaseFeaturedAdsListPayloadDto);

const FasHealthFeaturedAdsListPayloadDto = z
  .object({
    hc_placement: z.literal('TYP'),
    PublisherCampaignId: z.literal(14),
  })
  .merge(HealthFeaturedAdsListPayloadDto);

const AllHealthFeaturedAdsListPayloadDto = z
  .object({
    hc_placement: z.enum(['EMAIL', 'SURVEY']),
    PublisherCampaignId: z.literal(0),
  })
  .merge(HealthFeaturedAdsListPayloadDto);

const MedicareFeaturedAdsListPayloadDto = z
  .object({
    product: z.literal('MEDICARE'),
    hc_product_type: z.literal(2),
  })
  .merge(BaseFeaturedAdsListPayloadDto);

const TypMedicareFeaturedAdsListPayloadDto = z
  .object({
    hc_placement: z.literal('TYP'),
    PublisherCampaignId: z.literal(24),
  })
  .merge(MedicareFeaturedAdsListPayloadDto);

const AllMedicareFeaturedAdsListPayloadDto = z
  .object({
    hc_placement: z.enum(['EMAIL', 'SURVEY']),
    PublisherCampaignId: z.literal(0),
  })
  .merge(MedicareFeaturedAdsListPayloadDto);

const MedicareAdvantageFeaturedAdsListPayloadDto = z
  .object({
    hc_placement: z.enum(['SURVEY', 'TYP']),
    product: z.literal('MEDICARE_ADVANTAGE'),
    hc_product_type: z.literal(4),
    PublisherCampaignId: z.literal(0),
  })
  .merge(BaseFeaturedAdsListPayloadDto);

export const FeaturedAdsListPayloadDto = z.union([
  FasHealthFeaturedAdsListPayloadDto,
  AllHealthFeaturedAdsListPayloadDto,
  TypMedicareFeaturedAdsListPayloadDto,
  AllMedicareFeaturedAdsListPayloadDto,
  MedicareAdvantageFeaturedAdsListPayloadDto,
]);

export type FeaturedAdsListPayloadDto = z.infer<
  typeof FeaturedAdsListPayloadDto
>;
